import React from 'react';

const Explore: React.FC = () => {
    return (
        <>
      
        </>
    );
}

export default Explore;
